import { IonIcon } from '@ionic/react'
import { chevronDownOutline } from 'ionicons/icons'
import {
  formatDateTime,
  formatHours,
  workedMinutes,
} from '../../../helpers/timesheet'
import { ClockOutPendingLabel } from './ClockOutPendingLabel'
import { TimeClockDetail } from './TimeClockDetail'
import type { TimesheetShift } from './types'

/** Expandable shift row (v1 TimeShiftItem). */
export const TimeShiftItem = ({
  shift,
  expanded,
  onToggle,
}: {
  shift: TimesheetShift
  expanded: boolean
  onToggle: () => void
}) => (
  <div className='tc-history-shift'>
    <button
      type='button'
      className='tc-history-shift-header'
      onClick={onToggle}
    >
      <span className='tc-history-shift-date'>
        {formatDateTime(shift.startTime)}
      </span>
      <ClockOutPendingLabel
        endTime={shift.endTime}
        className='tc-history-shift-end'
      />
      <span className='tc-history-shift-dur'>
        {formatHours(workedMinutes(shift))}
      </span>
      <IonIcon
        icon={chevronDownOutline}
        className={`tc-history-caret ${expanded ? 'tc-history-caret--open' : ''}`}
      />
    </button>
    {expanded && (
      <div className='tc-history-entries'>
        {shift.timeClocks.map((tc) => (
          <TimeClockDetail key={tc.id} timeClock={tc} />
        ))}
      </div>
    )}
  </div>
)
